import { Component, NgZone, OnInit } from '@angular/core';
import { HelperService } from '../../services/helper.service';
import { SupaService, UserPermissions } from '../../services/supa.service';
import { User } from '@supabase/supabase-js';
@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent{

  helpurl="https://www.youtube.com/embed/IZpgM6_zM9g"
  provider_id: string | undefined = undefined
  user:UserPermissions|undefined=undefined;

  constructor(public supa: SupaService, private zone: NgZone, private helper: HelperService) {}

  signOut() {
    this.helper.notify('Signing out', 'dark')
    this.supa.signOut()
  }

}